export default __webpack_public_path__ + "static/i-help-machines-meet-us-where-we-are-45b655cbb000111acc40da93b99eb032.svg";